import { Action, Module, Mutation } from "vuex-module-decorators";
import { RootState } from "@/store";
import type { PaginationDataState } from "@/types";
import PaginationModule from "@/store/base-modules/PaginationModule";
import { queryRequest, handlePaginationData } from "@/utils/request";
import {
  queryStoreAnswerPaperPage,
  queryInspectionsTaskPage,
  getStoreAnswerPaper,
  updateStoreAnswerPaper,
  validLocation
} from "@/graphql/shop.gql";
export interface IShopCheckState extends PaginationDataState {}
@Module({ name: "ShopCheckModule", namespaced: true })
export default class ShopCheckModule
  extends PaginationModule<IShopCheckState, RootState>
  implements IShopCheckState {
  public taskList = [];
  public storeCheckDetail = {};
  @Mutation
  setTaskListMutation(data = []) {
    this.taskList = data;
  }
  @Mutation
  addTaskListMutation(data = []) {
    this.taskList.push(...data);
  }
  @Mutation
  saveStoreCheckDetail(data = {}) {
    this.storeCheckDetail = data;
  }
  // 提交
  @Action
  async updateStoreAnswerPaper(data) {
    return await queryRequest({
      query: updateStoreAnswerPaper,
      variables: { input: data }
    });
  }
  // 验证定位
  @Action
  async validLocation(data) {
    const { locationLon, locationLat } = data;
    return await queryRequest({
      query: validLocation,
      variables: { locationLon, locationLat }
    });
  }

  // 获取门店排名
  @Action
  async queryStoreAnswerPaperPage() {
    const {
      dataList = [],
      pageInfo: { totalCount }
    } = await queryRequest({
      query: queryStoreAnswerPaperPage,
      variables: {
        input: {
          showFlag: 1
        },
        pageInput: { pageNum: 1, pageSize: 10 }
      }
    });
    console.log(dataList, totalCount, "列表数据");
    return dataList;
  }
  // 获取任务列表
  @Action
  async queryInspectionsTaskPage(input) {
    const {
      commit,
      state: {
        paginationData: { pageNum, pageSize },
        paginationData
      }
    } = this.context;
    const { year, states } = input;
    const { data = [], totalCount } = handlePaginationData(
      await queryRequest({
        query: queryInspectionsTaskPage,
        variables: {
          input: {
            year,
            states
          },
          pageInput: { pageNum, pageSize }
        }
      })
    );
    commit(
      paginationData.pageNum === 1
        ? "setTaskListMutation"
        : "addTaskListMutation",
      data
    );
    console.log(data, "获取到的");
    console.log(totalCount, "获取到的");
    commit("savePaginationData", { pageNum, pageSize, totalCount });
  }
  // 门店审核结果
  @Action
  async getStoreAnswerPaper(input) {
    const { commit } = this.context;
    let data: any = {};
    try {
      data = await queryRequest({
        query: getStoreAnswerPaper,
        variables: {
          ...input
        }
      });
    } catch (err) {
      console.log(err, "获取门店详情信息错误");
    }
    data?.storeAnswerPaperInfoDomains?.forEach(item => {
      item["imageArray"] = ([]
        .concat(item.videoInfo ? item.videoInfo?.split(",") : [])
        .concat(item.imageInfo ? item.imageInfo?.split(",") : []) as any).map(
        _ => {
          return {
            url: _
          };
        }
      );
    });
    commit("saveStoreCheckDetail", data);
  }
}
